export default {
  mounted: function mounted() {
    var _this = this;

    if (this.spec && this.spec.extensions) {
      this.spec.extensions.forEach(function (name) {
        _this.extension[name](_this);
      });
    }
  }
};